import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SharedCryptoSelect = _resolveComponent("SharedCryptoSelect")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(_ctx.b())
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.b('score-head'))
    }, [
      _createElementVNode("h3", {
        class: _normalizeClass(_ctx.b('title'))
      }, _toDisplayString(_ctx.title), 3),
      _renderSlot(_ctx.$slots, "header-extra")
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.b('score-main'))
    }, [
      _renderSlot(_ctx.$slots, "amount"),
      _createVNode(_component_SharedCryptoSelect, {
        placeholder: _ctx.$t('Выберите счет'),
        options: _ctx.options,
        value: _ctx.value,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:value', $event))),
        onCreate: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('create')))
      }, null, 8, ["placeholder", "options", "value"])
    ], 2),
    _renderSlot(_ctx.$slots, "footer")
  ], 2))
}